import { COOKIE_CONFIG } from "./env";

interface CookieOptions {
  secure?: boolean;
  domain?: string;
  expires?: number;
  path?: string;
}

export function getCookie(name: string): string | undefined {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "=([^;]*)"),
  );
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function setCookie(name: string, value: string, options: CookieOptions = {}): void {
  const opts = { path: "/", ...options };
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (opts.expires) {
    const date = new Date();
    date.setTime(date.getTime() + opts.expires * 86400000);
    cookie += `; expires=${date.toUTCString()}`;
  }

  if (opts.path) cookie += `; path=${opts.path}`;
  if (opts.domain) cookie += `; domain=${opts.domain}`;
  if (opts.secure) cookie += "; secure";

  document.cookie = cookie;
}

export function removeCookie(name: string, options: CookieOptions = {}): void {
  setCookie(name, "", { ...options, expires: -1 });
}

export const defaultCookieConfig: CookieOptions = {
  secure: COOKIE_CONFIG.secure,
  domain: COOKIE_CONFIG.domain,
  path: "/",
};
